import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import { formatDateDataGrid } from "src/utils/format-date"

import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterJurosTable = (props) => {
    const datalakeService = new DatalakeService()

    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .catch(props.callbackError)
            .finally(() => props.loading(false))
    }


    const updateRow = async (newRow) => {
        const {
            ID,
            IDJuros,
            JurosCapitalizacao,
            CalculoDias,
            Tipo,
            Base,
            Anual,
            N,
            NUmeradorAnual,
            BaseAnual,
            Calculo
        } = newRow

        const body = {
            IDJuros,
            JurosCapitalizacao,
            CalculoDias,
            Tipo,
            Base,
            Anual,
            N,
            NUmeradorAnual,
            BaseAnual,
            Calculo
        }

        props.loading(true)

        return datalakeService
            .updateTableEndpoint(props.endpoint, ID, body)
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint, query, limit, offset)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService
            .paginate(endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            minWidth: 80,
            disableColumnMenu: true,
            disableFilter: true,
            editable: false
        },
        {
            field: 'IDJuros',
            headerName: 'IDJuros',
            minWidth: 110,
            editable: false,
            typeComponent: 'number',
            disableColumnMenu: true,
        },
        {
            field: 'JurosCapitalizacao',
            headerName: 'JurosCapitalizacao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: false
        },
        {
            field: 'Tipo',
            headerName: 'Tipo',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: false
        },
        {
            field: 'Base',
            headerName: 'Base',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: false,
        },
        {
            field: 'Anual',
            headerName: 'Anual',
            minWidth: 150,
            editable: false,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'N',
            headerName: 'N',
            minWidth: 150,
            editable: false,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'NumeradorAnual',
            headerName: 'NumeradorAnual',
            minWidth: 150,
            editable: false,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'BaseAnual',
            headerName: 'BaseAnual',
            minWidth: 150,
            editable: false,
            typeComponent: 'number',
            disableColumnMenu: true
        },
        {
            field: 'Calculo',
            headerName: 'Calculo',
            minWidth: 180,
            editable: false,
            disableColumnMenu: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            minWidth: 150,
            editable: false,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            minWidth: 150,
            editable: false,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            updateRow={updateRow}
            pagination={pagination}
            onChangePage={changePage}
            filterFunction={onFilter}
            customFilter={true}
            useDeleteButton={false}
        />
    )
}

ParameterJurosTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterJurosTable
